export const courses = [
  {
    id: 1,
    titleLines: ["4-HOUR", "BASIC", "DRIVER IMPROVEMENT"],
    price: "$29.50",
    description:
      "The 4-hour Florida Online Traffic School is the most common course to avoid points on your driver's License.",
    infoUrl: "/4-hour-bdi-online",
    registerUrl:
      "https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=Mzgy",
  },
  {
    id: 2,
    titleLines: ["8-HOUR", "INTERMEDIATE", "DRIVER IMPROVEMENT"],
    price: "$69.95",
    description:
      "The 8-hour may be taken to avoid points if you already took a 4-hour within the past year or to comply with a judgment.",
    infoUrl: "/8-hour-idi-course",
    registerUrl:
      "https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=MzIwMA==",
  },
  {
    id: 3,
    titleLines: ["FIRST TIME", "DRIVER & DMV", "PERMIT TEST"],
    price: "$29.95",
    description:
      "This course is required to get your license for the first time. Optional DMV Driver's License Permit Exam and Prep Course.",
    infoUrl: "/first-time-driver",
    registerUrl: "/first-time-driver",
  },
  {
    id: 4,
    titleLines: ["12-HOUR", "ADVANCED", "DRIVER IMPROVEMENT"],
    price: "$79.95",
    description:
      "This class may be taken in the event of a judgment, Point Suspension or Habitual Traffic Offender.",
    infoUrl: "/12-hour-adi",
    registerUrl: "https://12houradi.metrotrafficschool.com/register/MTY=",
  },
  {
    id: 5,
    titleLines: ["MATURE", "DRIVER", "COURSE"],
    price: "$29.50",
    description:
      "6-Hour Mature driver course for Florida drivers 55 and older to receive a car insurance discount guaranteed for 3 years.",
    infoUrl: "/mature-driver-course",
    registerUrl: "#",
  },
];
